// Module
var code = `<ng-form name="\$ctrl['form_{{\$ctrl.redFlagTagType}}']">
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#individual-tab-{{\$ctrl.redFlagTagType}}" data-toggle="tab">
          <i ng-show="\$ctrl['individualForm{{\$ctrl.redFlagTagType}}'].\$invalid" class="icon icon-warning-sign"></i>
          Individual
        </a>
      </li>
      <li>
        <a data-target="#individual-bda-tab-{{\$ctrl.redFlagTagType}}" data-toggle="tab">
          <i ng-show="\$ctrl['individualBDAForm{{\$ctrl.redFlagTagType}}'].\$invalid" class="icon icon-warning-sign"></i>
          Individual with BDA
        </a>
      </li>
      <li>
        <a data-target="#individual-restricted-tab-{{\$ctrl.redFlagTagType}}" data-toggle="tab">
          <i ng-show="\$ctrl['individualRestrictedForm{{\$ctrl.redFlagTagType}}'].\$invalid" class="icon icon-warning-sign"></i>
          Individual Restricted
        </a>
      </li>
      <li>
        <a data-target="#corporate-tab-{{\$ctrl.redFlagTagType}}" data-toggle="tab">
          <i ng-show="\$ctrl['corporateForm{{\$ctrl.redFlagTagType}}'].\$invalid" class="icon icon-warning-sign"></i>
          Corporate
        </a>
      </li>
    </ul>
  </div>
  <div class="tab-content">
    <div id="individual-tab-{{\$ctrl.redFlagTagType}}" class="tab-pane active">
      <customer-type-config
        ng-form="\$ctrl['individualForm{{\$ctrl.redFlagTagType}}']"
        config="\$ctrl.config.individual"
        compliance-configs-to-delete="\$ctrl.config.complianceConfigsToDelete"
        red-flag-tag-type="\$ctrl.redFlagTagType"
        customer-type="'INDIVIDUAL'"
        customer-subtype="null">
      </customer-type-config>
    </div>
    <div id="individual-bda-tab-{{\$ctrl.redFlagTagType}}" class="tab-pane">
      <customer-type-config
        ng-form="\$ctrl['individualBDAForm{{\$ctrl.redFlagTagType}}']"
        config="\$ctrl.config.individualBDA"
        compliance-configs-to-delete="\$ctrl.config.complianceConfigsToDelete"
        red-flag-tag-type="\$ctrl.redFlagTagType"
        customer-type="'INDIVIDUAL'"
        customer-subtype="'BDA'">
      </customer-type-config>
    </div>
    <div id="individual-restricted-tab-{{\$ctrl.redFlagTagType}}" class="tab-pane">
      <customer-type-config
        ng-form="\$ctrl['individualRestrictedForm{{\$ctrl.redFlagTagType}}']"
        config="\$ctrl.config.individualRestricted"
        compliance-configs-to-delete="\$ctrl.config.complianceConfigsToDelete"
        red-flag-tag-type="\$ctrl.redFlagTagType"
        customer-type="'INDIVIDUAL'"
        customer-subtype="'RESTRICTED'">
      </customer-type-config>
    </div>
    <div id="corporate-tab-{{\$ctrl.redFlagTagType}}" class="tab-pane">
      <customer-type-config
        ng-form="\$ctrl['corporateForm{{\$ctrl.redFlagTagType}}']"
        config="\$ctrl.config.corporate"
        compliance-configs-to-delete="\$ctrl.config.complianceConfigsToDelete"
        red-flag-tag-type="\$ctrl.redFlagTagType"
        customer-type="'CORPORATE'"
        customer-subtype="null">
      </customer-type-config>
    </div>
  </div>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/customer-type-transaction-bracket-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;